"use client";

import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { HelpCircle } from "lucide-react";
import * as React from "react";

import { cn } from "~/lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

function TooltipContent({ ref: reference, className, sideOffset = 4, ...props }: { ref?: React.Ref<React.ElementRef<typeof TooltipPrimitive.Content>> } & React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>) {
	return (
		<TooltipPrimitive.TooltipPortal>
			<TooltipPrimitive.Content
				className={cn(
					"z-50 overflow-hidden rounded-md border bg-background px-3 py-1.5 text-sm text-background-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
					className
				)}
				ref={reference}
				sideOffset={sideOffset}
				{...props}
			/>
		</TooltipPrimitive.TooltipPortal>
	);
}
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

function HelpTooltip({ children, ...props }: React.ComponentProps<typeof Tooltip>) {
	return (
		<Tooltip disableHoverableContent {...props}>
			<TooltipTrigger asChild>
				<HelpCircle className="ml-2 inline size-4 cursor-help" />
			</TooltipTrigger>
			<TooltipContent className="w-96" side="right">
				{children}
			</TooltipContent>
		</Tooltip>
	);
}

export { HelpTooltip, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
